<template>
  <div id="companyProducts"> 
    <Navigation/>
    <div class="container-fluid container_fluid">
      <div class="row fluid_row">

        <div class="col-md-12 Product_Ul">
            <swiper ref="swiper-container" :options="swiperOption">
                <swiper-slide class="swiper-slide" v-for="(targetTitle,id) in titleList" :key="id" @click="switchProducts(id)">
                  <img v-if="slientWidth < 750" :src="flag == id?targetTitle.app.checked:targetTitle.app.unchecked" class="imgUnchecked">
                  <span class="Product_li_span" :style="slientWidth < 750? targetTitle.app.fontColor:''"  @click="choseprofrom(id)" :class="{'secectBorder':flag==id}">{{targetTitle.name}}</span>
                </swiper-slide>
            </swiper>
        </div>

        <div class="col-md-12 top_nav">
          <div class="col-md-12 palm_top_nav">
              <img :src="slientWidth>750?titleList[flag].imgs['webImage']:''" class="palm_image">
          </div>
          <div v-if="flag == 0">
            <Palm/>
          </div>
          <div v-if="flag == 1 &&status==0">
            <WiseDoctor v-on:flagnum="flagValue"/>
          </div>
          <div v-if="flag == 2">
            <KnowGrass/>
          </div>
          <div v-if="flag == 3">
            <TerminalMachine/>
          </div>  
          <div v-if="status == 1">
            <ProductManual/>
          </div>  

          

        </div>
      </div>

    </div>
    <ReturnTop/>
    <HeadTail/>
  </div>
</template>

<script>
import navigation from './publicComponent/Navigation'
import headTail from './publicComponent/HeadTail'
import returnTop from './publicComponent/ReturnTop'
import palm from './Products/Palm'
import wiseDoctor from './Products/WiseDoctor'
import knowGrass from './Products/KnowGrass'
import terminalMachine from './Products/TerminalMachine'
import ProductManual from './Products/ProductManual'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide ,swiperWrapper} from 'vue-awesome-swiper'
export default {
  data(){
    return{
      status:0,
      titleList:[
        {name:"掌上青囊",id:0,
          imgs:{
            webImage:'../../static/image/ProductsImage/webPalm.png',
            appImage:'../../static/image/ProductsImage/appPalm.png',
          },
          app:{
            unchecked:'../../static/image/ProductsImage/appPalmUnchecked.png',
            checked:'../../static/image/ProductsImage/appPalm.png',
            fontColor:'color: #005eab;'
          }
        },
        {name:"杏林智医",id:1,
          imgs:{
            webImage:'../../static/image/ProductsImage/webWiseDoctor.png',
            appImage:'../../static/image/ProductsImage/appWiseDoctor.png',
          },
          app:{
            unchecked:'../../static/image/ProductsImage/appWiseUnchecked.png',
            checked:'../../static/image/ProductsImage/appWiseDoctor.png',
            fontColor:'color: #ed7b30;'
          }       
        },
        {name:"书香识芳草",id:2,
          imgs:{
            webImage:'../../static/image/ProductsImage/webKnowGrass.png',
            appImage:'../../static/image/ProductsImage/appKnowGrass.png',
          },
          app:{
            unchecked:'../../static/image/ProductsImage/appPalmUnchecked.png',
            checked:'../../static/image/ProductsImage/appKnowGrass.png',
            fontColor:'color: #3e94dd;'
          }
          },
        {name:"中医药文化传播终端",id:3,
          imgs:{
            webImage:'../../static/image/ProductsImage/webTerminalMachine.png',
            appImage:'../../static/image/ProductsImage/appTerminalMachine.png',
          },
          app:{
            unchecked:'../../static/image/ProductsImage/appPalmUnchecked.png',
            checked:'../../static/image/ProductsImage/appTerminalMachine.png',
            fontColor:'color: #3e94dd;'
          }
        },
      ],
      slientWidth:document.body.clientWidth,
      flag : 0,
      swiperOption:{},
      startPointX: 0,
      changePointX: 0,
      showIndex: 0,
      margLeft:null, 
      qid:null,
      
    }
  },
  computed: {
      swiper() {
        return this.$refs.content_text_div.swiper
      }
  },
  created(){
    if(this.$route.query.qid !== null && this.$route.query.qid !== undefined && this.$route.query.qid !== ''){
      this.flag = this.$route.query.qid
    }
    let thct=this;
    thct.swiperOption={
      slidesPerView: 4,
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },  
    }
  },
  methods:{
      choseprofrom:function (id) {
        this.flag = id;
        this.status = 0;
      },
      show(index){
      this.changePointX=this.startPointX;
      let slider = document.getElementById('slider');
      this.margLeft  = `-${70*index}px !important`;
      },
      touchstart(e){
        this.startPointX = e.changedTouches[0].pageX;
      },
      touchmove(e){
        if(this.startPointX==this.changePointX){
          return ;
        }
        let currPointX = e.changedTouches[0].pageX;
        let leftSlide = this.startPointX-currPointX;
        if(leftSlide>30&&this.showIndex<this.titleList.length-1){
          this.show(++this.showIndex)
        }else if(leftSlide<-30&&this.showIndex>0){
          this.show(--this.showIndex)
        }
      },
      flagValue(data){
        console.log(data)
        this.status=data;
        this.flag=1;
      }

  },
  components: {
    'HeadTail': headTail,  //将别名demo 变成 组件 Demo
    "Navigation":navigation,
    "ReturnTop" : returnTop ,
    'Palm' :palm,
    'WiseDoctor' : wiseDoctor,
    'KnowGrass' : knowGrass,
    'TerminalMachine' : terminalMachine,
    ProductManual,
    swiper,
    swiperSlide,
    swiperWrapper
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 750px){
    .top_nav{
        margin-top: 3% !important;
    }
    .Product_Ul{
        position: absolute;
        top: 0;
        list-style: none;
        width: 100%;
        text-align: center;
        z-index: 100;
        float: left;
        margin-top: 9.33% !important;
        clear: both;
    }
    .Product_li_span{
        height: 3.1vh !important;
        display: inline-block;
        color: #fff;
        cursor:pointer;
    }
    .secectBorder{
        border-bottom: 2.5px solid #ffff;
    }
    .palm_image{
      width: 100%;
    }
    .slider{
        overflow: hidden;
        display: flex;
    }
    .slider_conts{
        width: 42.5vw;
        height: 14vh;
        /* border: 1px solid; */
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: column;
        /* background: #fff; */
        border-radius: 10px;
        margin-right: 2% !important;
    }
}

/* 移动端特殊样式 */
@media screen and (max-width: 750px){
  .palm_image{
      width: 20%;
  }
  .Product_Ul{
    z-index: 100;
    display: flex;
    position: relative;
    overflow: hidden;
    touch-action: none;
  }
  .imgUnchecked{
      /* padding-left: 2% !important;
      padding-right: 7% !important;
      padding-top: 16% !important; */
      /* margin-top: 3vh !important;
      width: 32vw;
      box-shadow: 0px 3px 3px #a3becc !important;
      border-radius: 5px; */
      width: 100%;
      box-shadow: 0px 3px 3px #a3becc !important;
      border-radius: 5px;
    }
  .Product_li_span{
    position: absolute;
  }
  .secectBorder{
    color: #fff !important;
  }
  .slider{
        overflow: hidden;
        /* white-space: nowrap; */
        transition: 1s; 
        padding: 0 calc(42vw - 160px) !important;
        display: flex;
    }
    .slider_conts{
        width: 42.5vw;
        height: 14vh;
        /* border: 1px solid; */
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: column;
        background: #fff;
        border-radius: 10px;
        margin-right: 2% !important;
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      margin: 2vh auto !important;
    }
    .swiper-slide {
      text-align: center;
      font-size: 1em;
      background: #fff;
      width: 21% !important;
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      /* border: 1px solid red; */
      margin: 2vh 2vw 2vh 2vw !important;

    }
}

</style>



// WEBPACK FOOTER //
// src/components/CompanyProducts.vue